import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CommentEditorSource } from '../redux/types';
import { CommentEditorContext, EditorContext } from '../context';
import { useEditorDraftActions } from './useEditorDraftActions';
/**
 * Provides a function that will cancel a comment! Completely! It'll be removed from drafts
 * and we'll close the relevant editor.
 *
 * Relies on all the contexts provided by `<CommentEditorProviders />`,
 * so be sure you have it set up first!
 */
export function useCommentCancelAction(_a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, onCancel = _c.onCancel;
    var t = useTranslation().t;
    var _d = useContext(CommentEditorContext), editorId = _d.editorId, editorSource = _d.editorSource, collapseEditor = _d.collapseEditor;
    var _e = useContext(EditorContext), editorState = _e.state, editorApi = _e.api;
    var removeEditorDraft = useEditorDraftActions(editorId).removeEditorDraft;
    var isEmpty = (_b = editorState === null || editorState === void 0 ? void 0 : editorState.isEmpty) !== null && _b !== void 0 ? _b : true;
    return useCallback(function () {
        removeEditorDraft();
        if (editorSource !== CommentEditorSource.Edit && !isEmpty) {
            var cancel = confirm(t('commentbox.editor.cancel.confirm'));
            if (!cancel) {
                return;
            }
            editorApi === null || editorApi === void 0 ? void 0 : editorApi.clearEditor(true);
        }
        collapseEditor();
        onCancel && onCancel();
    }, [
        isEmpty,
        editorSource,
        removeEditorDraft,
        t,
        editorApi,
        onCancel,
        collapseEditor,
    ]);
}
//# sourceMappingURL=useCommentCancelAction.js.map